$(document).ready(function (){

	const videoSliderThumbs = new window.Swiper('.ce__videoslider--control', {
		slidesPerView: 1,
		spaceBetween: 30,
		slideToClickedSlide: true,
		freeMode: false,
		a11y: {
			enabled: false
		},
		breakpoints: {
			992: {
				spaceBetween: 0,
				touchRatio: 0.2,
				resistanceRatio: 0,
				slidesPerView: 'auto',
				freeMode: true,
			}
		}
	})

	const videoSlider = new window.Swiper('.ce__videoslider--slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		// autoHeight: true,
		noSwiping: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		a11y: {
			prevSlideMessage: 'Vorheriges Element',
			nextSlideMessage: 'Nächstes Element',
		},
		navigation: {
			nextEl: '.ce__videoslider--slider .swiper-news-next',
			prevEl: '.ce__videoslider--slider .swiper-news-prev',
		},
		keyboard: {
			enabled: true,
			pageUpDown: false
		},
		thumbs: {
			swiper: videoSliderThumbs,
		},
		breakpoints: {
			992: {
				noSwiping: true,
			}
		}
    });

	videoSlider.on('slideChangeTransitionEnd', function(){

		// const btn = videoSlider.slides[videoSlider.realIndex].querySelector('button')

		// if (btn) {
		// 	btn.focus()
		// }

		$.each(videoSlider.slides, (i, slide) => {

			const vid = slide.querySelector('video')

			if (vid && !vid.paused) {
				vid.pause()
				// vid.load()
				// vid.removeAttribute('controls')
				// vid.classList.add('object-cover')
			}
		})
	})

	// $('video').each(function(){

	// 	const video = $(this)[0]

	// 	video.onpause = function() {
	// 		video.removeAttribute('controls')
	// 	}
	// })

	// $('.btn-play').each(function(){

	// 	$(this).on('click', function(){
	// 		$(this).prev().removeClass('object-cover').attr('controls', '')[0].play()
	// 	})
	// })
});
